import {filter} from 'lodash';

import {getApiConfig} from "../../utilities";
import * as actionTypes from "../../constants/actionTypes";
import {getChangesCount, isItemChanged, isItemComplete} from "./TaxesReducer";
import {loadingDialog_show, messageBox_Show} from "../../actions";

export const TYPES = {
  ADD_NEW_ITEM: 'taxes/add-new-item',
  GET_TAX_LOCATIONS_REQUEST: 'taxes/get-tax-locations-request',
  GET_TAX_LOCATIONS_ANSWER: 'taxes/get-tax-locations-answer',
  REMOVE_ITEM: 'taxes/remove-item',
  UPDATE_ITEM: 'taxes/update-item',
  GET_TAX_GROUPS_REQUEST: 'taxes/get-tax-groups-request',
  GET_TAX_GROUPS_ANSWER: 'taxes/get-tax-groups-answer',
  MAKE_ITEM_EDITABLE: 'taxes/make-tax-location-editable',
  SAVE_ITEMS_REQUEST: 'taxes/save-tax-location-request',
  SAVE_ITEMS_ANSWER: 'taxes/save-tax-location-answer',
  ORDER_ITEMS: 'taxes/order-items',
  SET_CURRENT_GROUP: 'taxes/set-current-group',
  SET_ITEMS_GROUP_REQUEST: 'taxes/set-items-group-request',
  SET_ITEMS_GROUP_ANSWER: 'taxes/set-items-group-answer',
  ITEMS_DRILL_DOWN_REQUEST: 'taxes/items-drill-down-request',
  ITEMS_DRILL_DOWN_ANSWER: 'taxes/items-drill-down-answer',
  ITEMS_SET_SEARCH_TEXT_REQUEST: 'taxes/items-set-search-text-request',
  ITEMS_SET_SEARCH_TEXT_ANSWER: 'taxes/items-set-search-text-answer',
  ITEMS_CANCEL_CLICK: 'taxes/items-cancel-click',
  SET_FILTER_GROUP: 'taxes/set-filter-group'
};

export const FILTER_GROUP_TYPE_GROUP = 'group';
export const FILTER_GROUP_TYPE_ITEM = 'item';

export function setFilterGroup(region, group) {
  return (dispatch, getState) => {
    const {taxes} = getState();

    const {post} = getApiConfig('taxes/items');
    return post({
      filterBy: {
        region,
        regionGroup: group
      }
    })
      .then(result => {
        dispatch({type: TYPES.SET_FILTER_GROUP, payload: {region, group}});
        dispatch({
          type: TYPES.GET_TAX_LOCATIONS_ANSWER,
          payload: result
        })
      })
  }
}

export function setFilterGroupItem(group, item) {

}

export function handleCancelClick() {
  return (dispatch, getState) => {
    dispatch(messageBox_Show(true, 'system', 'Cancel', 'Are you sure? You will loose all your changes.',
      [{
        text: 'OK',
        onClick: () => {
          dispatch(messageBox_Show(false));
          dispatch(setSearchText(''));
        }
      },
        {
          text: 'Cancel',
          onClick: () => dispatch(messageBox_Show(false))
        }]))
  }
}

export function setSearchText(text) {
  return (dispatch, getState) => {
    const {taxes} = getState();

    dispatch({type: TYPES.ITEMS_SET_SEARCH_TEXT_REQUEST, payload: {text}});

    const {level} = taxes;

    const {post} = getApiConfig(`taxes/items`);
    return post({filterBy: {name: text, level: level}})
      .then(result => {
        dispatch({type: TYPES.ITEMS_SET_SEARCH_TEXT_ANSWER, payload: {text, result}});
      });
  }
}

export function itemsDrillDown(parentItem) {
  return (dispatch, getState) => {
    const {taxes} = getState();

    const changesAtCurrentLevel = getChangesCount(taxes);
    if (changesAtCurrentLevel) {
      dispatch(messageBox_Show(true, 'error', 'Error', 'Please save changes at this level, before adding sub-items.'));
      return;
    }

    dispatch({type: TYPES.ITEMS_DRILL_DOWN_REQUEST, payload: {parentItem}});
    let {level} = taxes;


    const {post} = getApiConfig(`taxes/items`);
    return post({
      filterBy: {parentItemId: +parentItem.id}
    })
      .then(result => {
        dispatch({type: TYPES.ITEMS_DRILL_DOWN_ANSWER, payload: {parentItem, result, level: level + 1}});
      });
  }
}

export function breadCrumbItemClick(item) {
  return (dispatch, getState) => {
    const {taxes} = getState();

    const {parentItem} = item;
    if (!parentItem && !item.root)
      return {};
    let {level} = taxes;
    if (level === item.level)
      return;

    level = item.level;

    dispatch({type: TYPES.ITEMS_DRILL_DOWN_REQUEST, payload: {parentItem}});
    const {post} = getApiConfig(`taxes/items`);
    return post({
      filterBy: {
        level: level
      }
    })
      .then(result => {
        dispatch({type: TYPES.ITEMS_DRILL_DOWN_ANSWER, payload: {parentItem, result, level}});
      });
  }
}

export function setItemsGroup(group) {
  return (dispatch, getState) => {
    dispatch({
      type: TYPES.SET_ITEMS_GROUP_REQUEST,
      group
    })

    const {taxes} = getState();
    const {post} = getApiConfig(`taxes/items/${taxes.level}/${group.id}`);
    return post({})
      .then(result => {
        dispatch({type: TYPES.SET_ITEMS_GROUP_ANSWER, payload: {group, result}});
      });
  }
}

export function addNewItem() {
  return (dispatch, getState) => {
    const {taxes} = getState();
    if (taxes.items.size && !isItemComplete(taxes.items.first())) {
      dispatch(messageBox_Show(true, 'error', 'Error', 'Please complete the first item.'));
      return;
    }

    dispatch({type: TYPES.ADD_NEW_ITEM});
  }
}

export function removeItem(item) {
  return dispatch => {
    if (item.uid !== '' && !item.id) {
      dispatch({type: TYPES.REMOVE_ITEM, item});
      return;
    }

    dispatch(messageBox_Show(true, 'system', 'Delete?', 'Are you sure? If this tax item has any descendants they will be delete as well?',
      [
        {
          'text': 'OK',
          'onClick': () => {
            dispatch({type: TYPES.REMOVE_ITEM, item});
            dispatch(messageBox_Show(false));
          }
        },
        {
          'text': 'Cancel',
          'onClick': () => {
            dispatch(messageBox_Show(false));
          }
        }
      ]))
  }
}

export function updateItem(item, propertyName, value, isNumber = false, markAsChanged = true) {
  return {
    type: TYPES.UPDATE_ITEM,
    payload: {item, propertyName, value, isNumber, markAsChanged}
  }
}

export function makeItemEditable(item, editable) {
  return {
    type: TYPES.MAKE_ITEM_EDITABLE,
    payload: {editable, item}
  }
}

export function getTaxLocations() {
  return (dispatch, getState) => {
    const state = getState();
    const {taxes} = state;

    dispatch({type: TYPES.GET_TAX_LOCATIONS_REQUEST});
    dispatch(loadingDialog_show(true, "Loading...", 'Loading taxes locations...'));

    const {post} = getApiConfig('taxes/items/');

    return post({
      filterBy: {
        level: taxes.level
      }
    })
      .then(result => {
        dispatch({type: actionTypes.POPUP_IN_PROGRESS, payload: {show: false}});
        dispatch({
          type: TYPES.GET_TAX_LOCATIONS_ANSWER,
          payload: result
        })
      })
  }
}

export function saveTaxLocations(taxRegion, taxRegionGroup) {
  return (dispatch, getState) => {
    const state = getState();
    const {taxes} = state;

    const mi = taxes.items.filter(i => isItemComplete(i) || isItemChanged(i));
    const post = getApiConfig('taxes/save').post({
      level: +taxes.level,
      taxRegion,
      taxRegionGroup,
      taxLocationParentId: taxes.currentItem.get('id'),
      taxLocations: mi.toJS()
    });

    dispatch({type: TYPES.SAVE_ITEMS_REQUEST});
    dispatch(loadingDialog_show(true, "Loading...", 'Saving taxes...'));
    return post
      .then(answer => {
        dispatch({type: actionTypes.POPUP_IN_PROGRESS, payload: {show: false}});
        dispatch({type: TYPES.SAVE_ITEMS_ANSWER});
        dispatch(getTaxLocations());
      });
  }
}

export function setCurrentGroup(group) {
  return {
    type: TYPES.SET_CURRENT_GROUP,
    group
  }
}
